import { css } from 'styled-components';
const breakpoints = {
  hd: 1920,
  sd: 1366,
  cs: 1190,
  tablet: 1024,
  tabletPortrait: 800,
  phoneLarge: 680,
  phoneModal: 544,
  phone: 500
};
const BreakPoints = Object.keys(breakpoints);
export const trellisBreakpoint = BreakPoints.reduce((acc, label) => {
  acc[label] = `@media (max-width: ${breakpoints[label] / 16}em)`;
  return acc;
}, {});
export default Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (templateString, ...rest) => css(["@media (max-width:", "em){", "}"], breakpoints[label] / 16, css(templateString, ...rest));
  return acc;
}, {});